webpackJsonp([126236933479302],{

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    .tool,\n    .docs {\n      grid-template-columns: 1fr;\n    }\n  '], ['\n    .tool,\n    .docs {\n      grid-template-columns: 1fr;\n    }\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    h1 {\n      font-size: 2rem;\n    }\n\n    .tool {\n      padding: 0.75rem;\n    }\n\n    .panelHeader {\n      display: block;\n    }\n\n    .segmented {\n      margin-top: 0.75rem;\n      width: 100%;\n    }\n  '], ['\n    h1 {\n      font-size: 2rem;\n    }\n\n    .tool {\n      padding: 0.75rem;\n    }\n\n    .panelHeader {\n      display: block;\n    }\n\n    .segmented {\n      margin-top: 0.75rem;\n      width: 100%;\n    }\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(8);
	
	var _Breakpoints = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PageStyled = _styledComponents2.default.article.withConfig({
	  displayName: 'verifiable-bookmarklets__PageStyled',
	  componentId: 'sc-fqfo1x-0'
	})(['color:', ';*,*:before,*:after{box-sizing:border-box;}a,a:link,a:visited{color:', ';text-decoration:none;}a:hover{text-decoration:underline;}button,input,textarea{font:inherit;}.hero{margin-bottom:1.25rem;}.eyebrow{margin:0 0 0.35rem;font-size:0.78rem;font-weight:bold;letter-spacing:0.08em;text-transform:uppercase;color:', ';}h1{margin:0;font-size:2.4rem;line-height:1.05;}.hero p{max-width:760px;margin:0.65rem 0 0;font-size:1.05rem;line-height:1.45;}.hero .heroNote{font-size:0.85rem;line-height:1.4;opacity:0.85;}.tool{display:grid;grid-template-columns:minmax(0,1fr) minmax(280px,0.85fr);gap:1rem;align-items:start;padding:1.25rem;border:1px solid rgba(0,0,0,0.12);border-radius:14px;background:rgba(255,255,255,0.96);}.panel{min-width:0;}.panelHeader{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin-bottom:0.75rem;}h2{margin:0;font-size:1.35rem;}h3{margin:0 0 0.5rem;font-size:1.1rem;}label{display:block;margin-bottom:0.4rem;font-weight:bold;}input,textarea{display:block;width:100%;border:1px solid rgba(0,0,0,0.16);border-radius:10px;background:rgba(255,255,255,0.98);color:', ';box-shadow:inset 0 1px 2px rgba(0,0,0,0.03);transition:border-color 160ms ease,box-shadow 160ms ease,background-color 160ms ease;}input{height:auto;padding:0.78rem 1rem;}textarea{min-height:220px;padding:0.95rem 1rem;resize:vertical;line-height:1.45;font-family:Consolas,Monaco,\'Andale Mono\',monospace;}input:focus,textarea:focus{outline:none;border-color:', ';box-shadow:0 0 0 4px rgba(59,16,187,0.12);background:#fff;}.field{margin-bottom:0.85rem;}.sharedNotice{margin:0.5rem 0 0;color:', ';font-size:0.9rem;line-height:1.4;}.segmented{display:inline-grid;grid-template-columns:repeat(2,1fr);border:1px solid ', ';border-radius:3px;overflow:hidden;}.segmented button{min-width:76px;min-height:38px;height:100%;border:0;background:#fff;cursor:pointer;font-weight:600;}.segmented button + button{border-left:1px solid ', ';}.segmented .active{background:', ';color:', ';}.actions{display:flex;flex-wrap:wrap;gap:0.5rem;}.bookmarkletActions{gap:0.85rem;}.button{min-height:38px;padding:0.78rem 1.05rem;border:1px solid rgba(0,0,0,0.22);border-radius:6px;background:rgba(255,255,255,0.92);color:', ';font-weight:600;line-height:1;cursor:pointer;transition:background-color 160ms ease,border-color 160ms ease,transform 160ms ease;}.button:hover:not(:disabled){transform:translateY(-1px);background:#fff;border-color:rgba(0,0,0,0.32);}.button:focus,.segmented button:focus,.editNameButton:focus{outline:none;box-shadow:0 0 0 3px rgba(0,0,0,0.08);}.button:disabled{cursor:not-allowed;opacity:0.55;}.bookmarkletLink{display:inline-flex;align-items:center;min-height:40px;max-width:100%;margin:0 0 0.75rem;padding:0.45rem 0.75rem;border:1px solid ', ';border-radius:3px;background:', ';font-weight:bold;word-break:break-word;}.bookmarkletRow{display:flex;align-items:center;gap:0.5rem;margin-bottom:0.75rem;}.bookmarkletRow .bookmarkletLink{margin-bottom:0;}.bookmarkletNameInput{flex:1;min-width:0;}.editNameButton{width:36px;height:36px;padding:0;border:1px solid ', ';border-radius:3px;background:#fff;color:', ';cursor:pointer;font-size:1.1rem;line-height:1;}.dropZone{min-height:140px;padding:0.75rem;border:1px dashed ', ';border-radius:3px;background:rgba(255,255,255,0.72);}.dropZone textarea{min-height:118px;border:0;background:transparent;padding:0;}.dropZone + .actions{margin-top:0.75rem;}.metaGrid{display:grid;grid-template-columns:90px minmax(0,1fr);gap:0.45rem 0.7rem;margin:0.85rem 0;font-size:0.9rem;}.metaGrid strong{color:', ';}.sourceValue{display:flex;flex-wrap:wrap;align-items:baseline;gap:0.35rem 0.65rem;min-width:0;}.mono{overflow-wrap:anywhere;font-family:Consolas,Monaco,\'Andale Mono\',monospace;}.status{margin:0.85rem 0;padding:0.75rem;border-left:4px solid ', ';background:rgba(85,26,139,0.06);line-height:1.4;white-space:pre-wrap;}.status.error{border-left-color:#b50c24;background:rgba(181,12,36,0.08);}.status.success{border-left-color:#487b31;background:rgba(72,123,49,0.1);}details{margin-top:0.85rem;}summary{cursor:pointer;font-weight:bold;}.docs{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1rem;margin-top:1.5rem;}.docBlock{padding:1rem;border:1px solid rgba(0,0,0,0.12);border-radius:10px;background:rgba(255,255,255,0.96);}.docBlock p,.docBlock li{line-height:1.45;}.docBlock ul{padding-left:1.1rem;}code{padding:0.1rem 0.25rem;background:', ';font-family:Consolas,Monaco,\'Andale Mono\',monospace;}', ';', ';'], _constants.colors.darkTextColor, _constants.colors.linkColor, _constants.colors.mediaColor, _constants.colors.darkTextColor, _constants.colors.gradientTop, _constants.colors.mediaColor, _constants.colors.bordersColor, _constants.colors.bordersColor, _constants.colors.mediaColor, _constants.colors.lightTextColor, _constants.colors.darkTextColor, _constants.colors.mediaColor, _constants.colors.contentWrappersBackground, _constants.colors.bordersColor, _constants.colors.darkTextColor, _constants.colors.mediaColor, _constants.colors.mediaColor, _constants.colors.mediaColor, _constants.colors.contentWrappersBackground, _Breakpoints.media.desktop(_templateObject), _Breakpoints.media.tablet(_templateObject2));
	
	var emptyInspection = {
	  decoded: '',
	  metadata: null,
	  metadataError: '',
	  payloadSha: '',
	  size: 0
	};
	
	var pageInfoSample = '(() => {\n  const description =\n    document.querySelector(\'meta[name="description"]\')?.getAttribute(\'content\') ||\n    \'No description found\'\n  const meta = Array.from(document.querySelectorAll(\'meta\'))\n    .map(element => {\n      const name = element.getAttribute(\'name\') || element.getAttribute(\'property\')\n      const content = element.getAttribute(\'content\')\n\n      return name && content ? name + \': \' + content : \'\'\n    })\n    .filter(Boolean)\n    .slice(0, 12)\n\n  alert([\n    \'Name: \' + (document.title || \'Untitled\'),\n    \'Description: \' + description,\n    \'Meta:\',\n    meta.length ? meta.join(\'\\n\') : \'No metadata found\',\n    \'Sample verifiable bookmarklet from https://robertovg.com/projects/verifiable-bookmarklets\',\n  ].join(\'\\n\\n\'))\n})()';
	
	function normalizeSource(source) {
	  return source.replace(/\r\n?/g, '\n').trim();
	}
	
	function minifySource(source) {
	  return normalizeSource(source);
	}
	
	function encodeBookmarkletValue(value) {
	  return encodeURIComponent(value).replace(/'/g, '%27').replace(/"/g, '%22');
	}
	
	function encodeBookmarkletBody(body) {
	  return 'javascript:' + encodeURIComponent(body);
	}
	
	function createPayload(source) {
	  return encodeBookmarkletBody('(()=>{' + minifySource(source) + '})()');
	}
	
	function createMetadata(sha, src) {
	  return src ? '/*bm:v1;sha=' + sha + ';src=' + encodeBookmarkletValue(src) + '*/' : '/*bm:v1;sha=' + sha + '*/';
	}
	
	function createBookmarklet(source, sha, src) {
	  return encodeBookmarkletBody('(()=>{' + createMetadata(sha, src) + minifySource(source) + '})()');
	}
	
	function decodeBookmarklet(bookmarklet) {
	  var trimmed = bookmarklet.trim();
	  var body = trimmed.indexOf('javascript:') === 0 ? trimmed.slice('javascript:'.length) : trimmed;
	
	  try {
	    return {
	      decoded: decodeURIComponent(body),
	      error: '',
	      hasScheme: trimmed.indexOf('javascript:') === 0
	    };
	  } catch (error) {
	    return {
	      decoded: body,
	      error: error.message,
	      hasScheme: trimmed.indexOf('javascript:') === 0
	    };
	  }
	}
	
	function parseMetadata(decoded) {
	  var matches = decoded.match(/\/\*bm:v1;[^*]*\*\//g);
	
	  if (!matches) {
	    return { metadata: null, error: '' };
	  }
	
	  if (matches.length !== 1) {
	    return { metadata: null, error: 'More than one bm:v1 metadata block found.' };
	  }
	
	  var raw = matches[0].slice(2, -2);
	  var parts = raw.split(';');
	
	  if (parts[0] !== 'bm:v1') {
	    return { metadata: null, error: 'Metadata must start with bm:v1.' };
	  }
	
	  var metadata = { bm: 'v1', raw: matches[0] };
	  var seen = {};
	
	  for (var i = 1; i < parts.length; i += 1) {
	    var part = parts[i];
	    var separatorIndex = part.indexOf('=');
	
	    if (!part || separatorIndex === -1) {
	      return { metadata: null, error: 'Metadata contains a malformed field.' };
	    }
	
	    var key = part.slice(0, separatorIndex);
	    var value = part.slice(separatorIndex + 1);
	
	    if (key !== 'sha' && key !== 'src') {
	      return { metadata: null, error: 'Unknown metadata field: ' + key + '.' };
	    }
	
	    if (seen[key]) {
	      return { metadata: null, error: 'Duplicate metadata field: ' + key + '.' };
	    }
	
	    seen[key] = true;
	    metadata[key] = key === 'src' ? decodeURIComponent(value) : value;
	  }
	
	  if (!metadata.sha) {
	    return { metadata: null, error: 'Missing sha field.' };
	  }
	
	  if (!/^[a-f0-9]{64}$/.test(metadata.sha)) {
	    return { metadata: null, error: 'sha must be 64 lowercase hex characters.' };
	  }
	
	  if (metadata.src && !/^https?:\/\//.test(metadata.src)) {
	    return { metadata: null, error: 'src must be an absolute http or https URL.' };
	  }
	
	  return { metadata: metadata, error: '' };
	}
	
	function removeMetadata(decoded) {
	  return decoded.replace(/\/\*bm:v1;[^*]*\*\//, '');
	}
	
	function getBookmarkletFromDrop(event) {
	  var data = event.dataTransfer;
	  var values = [data.getData('application/x-verifiable-bookmarklet'), data.getData('text/plain'), data.getData('text/uri-list'), data.getData('text')];
	
	  return values.find(function (value) {
	    var trimmedValue = value.trim();
	
	    return trimmedValue.indexOf('javascript:') === 0;
	  }) || '';
	}
	
	function validateSourceUrl(value) {
	  var sourceUrl = value.trim();
	
	  try {
	    var parsed = new URL(sourceUrl);
	    var path = parsed.pathname.split('/').filter(Boolean);
	
	    if (parsed.hostname === 'gist.github.com') {
	      if (!path[0] || !path[1]) {
	        throw new Error('This is a Gist URL but it is missing the user and gist id.');
	      }
	
	      // A Gist page URL is not fetchable, but the matching raw URL is: GitHub
	      // serves the raw file (the first one when a Gist has several) with
	      // permissive CORS headers. Convert it so the paste just works.
	      var revision = path[2] && path[2] !== 'raw' ? '/' + path[2] : '';
	
	      return 'https://gist.githubusercontent.com/' + path[0] + '/' + path[1] + '/raw' + revision;
	    }
	
	    if (parsed.hostname === 'gist.githubusercontent.com') {
	      if (path[2] !== 'raw' || !path[3]) {
	        throw new Error('Gist raw URLs must include the revision: https://gist.githubusercontent.com/<user>/<gist>/raw/<revision>[/<filename>]');
	      }
	    }
	  } catch (error) {
	    if (error.message.indexOf('Gist ') === 0 || error.message.indexOf('This is a Gist') === 0) {
	      throw error;
	    }
	
	    throw new Error('Enter a valid absolute http or https URL.');
	  }
	
	  return sourceUrl;
	}
	
	var HTML_SOURCE_START = /^\s*(<!doctype html|<html[\s>]|<\?xml)/i;
	
	// Checks that a fetched response actually looks like runnable JavaScript.
	// It never executes the code: `new Function` only compiles it, so a bad or
	// hostile source is rejected before it is turned into a bookmarklet.
	function assertRunnableSource(source, contentType) {
	  var trimmed = (source || '').trim();
	  var mediaType = (contentType || '').split(';')[0].trim().toLowerCase();
	
	  if (!trimmed) {
	    throw new Error('The source URL returned an empty response. There is no JavaScript to use.');
	  }
	
	  var looksLikeHtml = mediaType === 'text/html' || HTML_SOURCE_START.test(trimmed);
	
	  if (looksLikeHtml) {
	    throw new Error('The URL returned an HTML page, not JavaScript source. Use the raw file URL (for Gists, the gist.githubusercontent.com/.../raw/... link).');
	  }
	
	  if (mediaType === 'text/css' || mediaType === 'application/json' || mediaType === 'application/xml' || mediaType === 'text/xml' || mediaType === 'application/pdf' || /^(image|audio|video)\//.test(mediaType)) {
	    throw new Error('The URL returned ' + mediaType + ', not JavaScript source.');
	  }
	
	  try {
	    // Parse-only check: compiles the source as a function body without running it.
	    // eslint-disable-next-line no-new, no-new-func
	    new Function(trimmed);
	  } catch (error) {
	    if (error instanceof SyntaxError) {
	      throw new Error('The fetched source is not valid JavaScript and cannot be run: ' + error.message);
	    }
	    // Non-syntax errors (for example a CSP that blocks eval) mean we could not
	    // verify the syntax here; let the source through rather than false-flagging it.
	  }
	
	  return trimmed;
	}
	
	function inferBookmarkletName(sourceUrl) {
	  try {
	    var parsed = new URL(sourceUrl);
	    var path = parsed.pathname.split('/').filter(Boolean);
	    var filename = path[path.length - 1] || '';
	
	    for (var i = 0; i < 2; i += 1) {
	      var decodedFilename = decodeURIComponent(filename);
	
	      if (decodedFilename === filename) {
	        break;
	      }
	
	      filename = decodedFilename;
	    }
	
	    return filename.replace(/\.[^/.]+$/, '');
	  } catch (error) {
	    return '';
	  }
	}
	
	// A filename-less Gist raw URL ends in the revision hash (or "raw"), which is
	// not a useful name. Detect that so we can fall back to reading the source.
	function looksLikeGistRevision(name) {
	  return !name || name === 'raw' || /^[0-9a-f]{7,40}$/i.test(name);
	}
	
	// Best-effort readable name pulled from a leading comment / heading in the
	// source, for example "# Full Site to Markdown Extractor" -> that text.
	function inferNameFromSource(source) {
	  if (!source) {
	    return '';
	  }
	
	  var lines = source.split('\n');
	
	  for (var i = 0; i < lines.length && i < 25; i += 1) {
	    var cleaned = lines[i].replace(/^\s*\/\*+/, '').replace(/\*+\/\s*$/, '').replace(/^\s*\*+/, '').replace(/^\s*\/\/+/, '').replace(/^\s*#+\s*/, '').trim();
	
	    if (!cleaned || cleaned.length > 80) {
	      continue;
	    }
	
	    // Skip lines that look like actual code rather than a title.
	    if (/[{};]|=>|\bfunction\b/.test(cleaned)) {
	      continue;
	    }
	
	    return cleaned;
	  }
	
	  return '';
	}
	
	function getGistPageUrl(sourceUrl) {
	  try {
	    var parsed = new URL(sourceUrl);
	    var path = parsed.pathname.split('/').filter(Boolean);
	
	    if (parsed.hostname !== 'gist.githubusercontent.com' || path.length < 4 || path[2] !== 'raw') {
	      return '';
	    }
	
	    return 'https://gist.github.com/' + path[0] + '/' + path[1] + '/' + path[3];
	  } catch (error) {
	    return '';
	  }
	}
	
	function createShareUrl(sourceUrl) {
	  if (typeof window === 'undefined') {
	    return '';
	  }
	
	  var shareUrl = new URL(window.location.href);
	  shareUrl.search = '';
	  shareUrl.searchParams.set('src', sourceUrl);
	
	  return shareUrl.toString();
	}
	
	function copyText(value) {
	  if (typeof navigator === 'undefined' || !navigator.clipboard || !navigator.clipboard.writeText) {
	    return Promise.reject(new Error('Clipboard access is not available in this browser.'));
	  }
	
	  return navigator.clipboard.writeText(value);
	}
	
	var VerifiableBookmarkletsPage = function (_React$Component) {
	  _inherits(VerifiableBookmarkletsPage, _React$Component);
	
	  function VerifiableBookmarkletsPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VerifiableBookmarkletsPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      inputMode: 'url',
	      actionMode: 'generate',
	      sourceCode: pageInfoSample,
	      sourceUrl: '',
	      bookmarklet: '',
	      generatedBookmarklet: '',
	      generatedSha: '',
	      generatedMetadata: '',
	      inspection: emptyInspection,
	      status: '',
	      statusType: '',
	      loading: false,
	      bookmarkletName: 'Drag me to bookmarks',
	      bookmarkletNameEdited: false,
	      editingBookmarkletName: false,
	      sharedSource: false,
	      sourceLocked: false
	    }, _this.getActiveSource = function () {
	      var _this$state = _this.state,
	          inputMode = _this$state.inputMode,
	          sourceCode = _this$state.sourceCode,
	          sourceUrl = _this$state.sourceUrl;
	
	
	      if (inputMode === 'code') {
	        return Promise.resolve({
	          source: sourceCode,
	          src: ''
	        });
	      }
	
	      if (!sourceUrl.trim()) {
	        return Promise.reject(new Error('Add a source URL first.'));
	      }
	
	      var fetchUrl = void 0;
	
	      try {
	        fetchUrl = validateSourceUrl(sourceUrl);
	      } catch (error) {
	        return Promise.reject(error);
	      }
	
	      return fetch(fetchUrl).then(function (response) {
	        if (!response.ok) {
	          throw new Error(('Could not fetch source URL. HTTP ' + response.status + ' ' + response.statusText + '.').trim());
	        }
	
	        var contentType = response.headers.get('content-type') || '';
	
	        return response.text().then(function (source) {
	          return {
	            source: assertRunnableSource(source, contentType),
	            src: fetchUrl
	          };
	        });
	      }).catch(function (error) {
	        if (error.name === 'TypeError') {
	          throw new Error('Could not reach the source URL. The host may be offline or it blocked browser access (CORS). Use its raw URL or paste the source code instead.');
	        }
	
	        throw error;
	      });
	    }, _this.sha256 = function (value) {
	      if (typeof window === 'undefined' || !window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
	        return Promise.reject(new Error('SHA-256 needs a modern browser with crypto.subtle.'));
	      }
	
	      var bytes = new TextEncoder().encode(value);
	
	      return window.crypto.subtle.digest('SHA-256', bytes).then(function (hash) {
	        return Array.from(new Uint8Array(hash)).map(function (byte) {
	          return byte.toString(16).padStart(2, '0');
	        }).join('');
	      });
	    }, _this.setInputMode = function (inputMode) {
	      _this.setState({ inputMode: inputMode, status: '', statusType: '' }, function () {
	        if (inputMode === 'code' && _this.sourceCodeInput) {
	          _this.sourceCodeInput.focus();
	          _this.sourceCodeInput.select();
	        }
	      });
	    }, _this.setActionMode = function (actionMode) {
	      _this.setState({ actionMode: actionMode, status: '', statusType: '' });
	    }, _this.finishBookmarkletNameEdit = function () {
	      _this.setState(function (previousState) {
	        return {
	          bookmarkletName: previousState.bookmarkletName.trim() || 'Drag me to bookmarks',
	          editingBookmarkletName: false
	        };
	      });
	    }, _this.handleBookmarkletNameKeyDown = function (event) {
	      if (event.key === 'Enter') {
	        _this.finishBookmarkletNameEdit();
	      }
	
	      if (event.key === 'Escape') {
	        _this.setState({ editingBookmarkletName: false });
	      }
	    }, _this.generate = function () {
	      _this.setState({
	        loading: true,
	        status: '',
	        statusType: '',
	        generatedBookmarklet: '',
	        generatedSha: '',
	        generatedMetadata: '',
	        bookmarklet: '',
	        inspection: emptyInspection
	      });
	
	      Promise.resolve().then(_this.getActiveSource).then(function (_ref) {
	        var source = _ref.source,
	            src = _ref.src;
	
	        var payload = createPayload(source);
	
	        return _this.sha256(payload).then(function (sha) {
	          var bookmarklet = createBookmarklet(source, sha, src);
	          var metadata = createMetadata(sha, src);
	          var inferredName = _this.state.bookmarkletName;
	
	          if (src && !_this.state.bookmarkletNameEdited) {
	            var urlName = inferBookmarkletName(src);
	            var sourceName = looksLikeGistRevision(urlName) ? inferNameFromSource(source) : '';
	
	            inferredName = sourceName || urlName || _this.state.bookmarkletName;
	          }
	
	          return _this.inspectValue(bookmarklet).then(function (inspection) {
	            var shareUrl = src ? createShareUrl(src) : '';
	
	            if (shareUrl && typeof window !== 'undefined' && window.history.replaceState) {
	              window.history.replaceState({}, '', shareUrl);
	            }
	
	            _this.setState({
	              bookmarklet: bookmarklet,
	              generatedBookmarklet: bookmarklet,
	              generatedSha: sha,
	              generatedMetadata: metadata,
	              inspection: inspection,
	              bookmarkletName: inferredName || _this.state.bookmarkletName,
	              sourceUrl: src || _this.state.sourceUrl,
	              sharedSource: src ? true : _this.state.sharedSource,
	              sourceLocked: src ? true : _this.state.sourceLocked,
	              status: 'Generated. Drag the link to your bookmarks bar, or copy the bookmarklet text.',
	              statusType: 'success'
	            });
	
	            if (shareUrl) {
	              copyText(shareUrl).then(function () {
	                return _this.setState({ status: 'Generated. Share URL copied to the clipboard.' });
	              }, function () {
	                return undefined;
	              });
	            }
	          });
	        });
	      }).catch(function (error) {
	        _this.setState({
	          status: error.message,
	          statusType: 'error',
	          sourceLocked: false,
	          sharedSource: false
	        });
	      }).then(function () {
	        return _this.setState({ loading: false });
	      });
	    }, _this.inspectValue = function (bookmarklet) {
	      if (!bookmarklet.trim()) {
	        return Promise.resolve(emptyInspection);
	      }
	
	      var decodedBookmarklet = decodeBookmarklet(bookmarklet);
	      var metadataResult = parseMetadata(decodedBookmarklet.decoded);
	      var payloadBody = removeMetadata(decodedBookmarklet.decoded);
	      var payload = decodedBookmarklet.hasScheme ? encodeBookmarkletBody(payloadBody) : payloadBody;
	
	      return _this.sha256(payload).then(function (payloadSha) {
	        return {
	          decoded: decodedBookmarklet.decoded,
	          decodeError: decodedBookmarklet.error,
	          metadata: metadataResult.metadata,
	          metadataError: metadataResult.error,
	          payloadSha: payloadSha,
	          size: bookmarklet.length
	        };
	      });
	    }, _this.inspect = function () {
	      var bookmarklet = _this.state.bookmarklet;
	
	
	      _this.setState({ loading: true, status: '', statusType: '' });
	
	      _this.inspectValue(bookmarklet).then(function (inspection) {
	        _this.setState({
	          inspection: inspection,
	          status: bookmarklet.trim() ? 'Inspected without executing the bookmarklet.' : 'Paste or drag a bookmarklet first.',
	          statusType: bookmarklet.trim() ? '' : 'error'
	        });
	      }).catch(function (error) {
	        _this.setState({
	          status: error.message,
	          statusType: 'error'
	        });
	      }).then(function () {
	        return _this.setState({ loading: false });
	      });
	    }, _this.verify = function () {
	      var bookmarklet = _this.state.bookmarklet;
	
	
	      _this.setState({
	        loading: true,
	        status: '',
	        statusType: '',
	        generatedBookmarklet: '',
	        generatedSha: '',
	        generatedMetadata: '',
	        inspection: emptyInspection
	      });
	
	      if (!bookmarklet.trim()) {
	        _this.setState({
	          loading: false,
	          status: 'Paste or drag a bookmarklet first.',
	          statusType: 'error'
	        });
	        return;
	      }
	
	      _this.inspectValue(bookmarklet).then(function (inspection) {
	        if (!inspection.metadata || inspection.metadataError) {
	          throw new Error(inspection.metadataError || 'This bookmarklet has no bm:v1 metadata.');
	        }
	
	        return Promise.resolve().then(_this.getActiveSource).then(function (_ref2) {
	          var source = _ref2.source;
	          return _this.sha256(createPayload(source)).then(function (expectedSha) {
	            return {
	              expectedSha: expectedSha,
	              inspection: inspection
	            };
	          });
	        });
	      }).then(function (_ref3) {
	        var expectedSha = _ref3.expectedSha,
	            inspection = _ref3.inspection;
	
	        var matches = expectedSha === inspection.metadata.sha;
	
	        _this.setState({
	          inspection: inspection,
	          status: matches ? 'Bookmarklet matches the source.' : 'Bookmarklet does not match the source.',
	          statusType: matches ? 'success' : 'error'
	        });
	      }).catch(function (error) {
	        _this.setState({
	          status: error.message,
	          statusType: 'error'
	        });
	      }).then(function () {
	        return _this.setState({ loading: false });
	      });
	    }, _this.handleDrop = function (event) {
	      event.preventDefault();
	
	      var bookmarklet = getBookmarkletFromDrop(event);
	
	      if (bookmarklet) {
	        _this.setState({ bookmarklet: bookmarklet }, _this.inspect);
	        return;
	      }
	
	      _this.setState({
	        status: 'The browser blocked this bookmarklet while dragging it. Copy the bookmarklet text and paste it here, or drag the generated link from this page.',
	        statusType: 'error'
	      });
	    }, _this.clearBookmarklet = function () {
	      _this.setState({
	        bookmarklet: '',
	        generatedBookmarklet: '',
	        generatedSha: '',
	        generatedMetadata: '',
	        inspection: emptyInspection,
	        status: '',
	        statusType: '',
	        bookmarkletName: 'Drag me to bookmarks',
	        bookmarkletNameEdited: false,
	        editingBookmarkletName: false,
	        sourceUrl: '',
	        sharedSource: false,
	        sourceLocked: false
	      });
	    }, _this.copyShareUrl = function () {
	      var sourceUrl = _this.state.sourceUrl;
	
	
	      if (!sourceUrl) {
	        _this.setState({
	          status: 'Generate from a source URL before copying a share URL.',
	          statusType: 'error'
	        });
	        return;
	      }
	
	      copyText(createShareUrl(sourceUrl)).then(function () {
	        return _this.setState({ status: 'Share URL copied to the clipboard.', statusType: 'success' });
	      }, function (error) {
	        return _this.setState({ status: error.message, statusType: 'error' });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  VerifiableBookmarkletsPage.prototype.componentDidMount = function componentDidMount() {
	    var sharedSource = new URLSearchParams(window.location.search).get('src');
	
	    if (!sharedSource) {
	      return;
	    }
	
	    this.setState({
	      inputMode: 'url',
	      sourceUrl: sharedSource,
	      sharedSource: true,
	      sourceLocked: true,
	      actionMode: 'generate'
	    }, this.generate);
	  };
	
	  VerifiableBookmarkletsPage.prototype.renderMetadata = function renderMetadata() {
	    var _state = this.state,
	        inspection = _state.inspection,
	        generatedSha = _state.generatedSha,
	        generatedMetadata = _state.generatedMetadata;
	
	    var metadata = inspection.metadata;
	    var sourceUrl = metadata && metadata.src;
	    var gistPageUrl = sourceUrl ? getGistPageUrl(sourceUrl) : '';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'metaGrid' },
	      _react2.default.createElement(
	        'strong',
	        null,
	        'SHA'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'mono' },
	        metadata && metadata.sha || generatedSha || 'Not generated yet'
	      ),
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Source'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'sourceValue' },
	        _react2.default.createElement(
	          'span',
	          { className: 'mono' },
	          sourceUrl || 'Manual source'
	        ),
	        gistPageUrl ? _react2.default.createElement(
	          'a',
	          { href: gistPageUrl, target: '_blank', rel: 'noopener noreferrer' },
	          'View Gist'
	        ) : null
	      ),
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Metadata'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'mono' },
	        metadata && metadata.raw || generatedMetadata || 'None'
	      ),
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Size'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        inspection.size ? inspection.size + ' chars' : 'No bookmarklet yet'
	      )
	    );
	  };
	
	  VerifiableBookmarkletsPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state2 = this.state,
	        inputMode = _state2.inputMode,
	        actionMode = _state2.actionMode,
	        sourceCode = _state2.sourceCode,
	        sourceUrl = _state2.sourceUrl,
	        bookmarklet = _state2.bookmarklet,
	        generatedBookmarklet = _state2.generatedBookmarklet,
	        inspection = _state2.inspection,
	        status = _state2.status,
	        statusType = _state2.statusType,
	        loading = _state2.loading,
	        bookmarkletName = _state2.bookmarkletName,
	        bookmarkletNameEdited = _state2.bookmarkletNameEdited,
	        editingBookmarkletName = _state2.editingBookmarkletName,
	        sharedSource = _state2.sharedSource,
	        sourceLocked = _state2.sourceLocked;
	
	
	    return _react2.default.createElement(
	      PageStyled,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Verifiable Bookmarklets - Roberto V\xE1zquez Gonz\xE1lez Site' }),
	      _react2.default.createElement(
	        'header',
	        { className: 'hero' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Verifiable Bookmarklets'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Generate, inspect and verify bookmarklets without executing them.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'heroNote' },
	          'A bookmarklet is a normal browser bookmark that stores JavaScript instead of a web address. When you click it, the code runs on whatever page you are currently viewing, so you can automate small tasks on any site without installing an extension.'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'tool' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panelHeader' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Source'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'segmented', 'aria-label': 'Source input mode' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: inputMode === 'code' ? 'active' : '',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this2.setInputMode('code');
	                  }
	                },
	                'Code'
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: inputMode === 'url' ? 'active' : '',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this2.setInputMode('url');
	                  }
	                },
	                'URL'
	              )
	            )
	          ),
	          inputMode === 'url' ? _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'source-url' },
	              'Raw JavaScript URL'
	            ),
	            _react2.default.createElement('input', {
	              id: 'source-url',
	              value: sourceUrl,
	              placeholder: 'https://example.com/bookmarklet.js or a raw Gist URL',
	              disabled: sourceLocked,
	              onChange: function onChange(event) {
	                return _this2.setState({ sourceUrl: event.target.value });
	              }
	            }),
	            sharedSource ? _react2.default.createElement(
	              'p',
	              { className: 'sharedNotice' },
	              'This source was shared with this page, so the URL was loaded automatically.'
	            ) : null
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'source-code' },
	              'JavaScript source'
	            ),
	            _react2.default.createElement('textarea', {
	              id: 'source-code',
	              ref: function ref(element) {
	                _this2.sourceCodeInput = element;
	              },
	              value: sourceCode,
	              spellCheck: 'false',
	              onChange: function onChange(event) {
	                return _this2.setState({ sourceCode: event.target.value });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'actions' },
	            _react2.default.createElement(
	              'div',
	              { className: 'segmented', 'aria-label': 'Bookmarklet action' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: actionMode === 'generate' ? 'active' : '',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this2.setActionMode('generate');
	                  }
	                },
	                'Generate'
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: actionMode === 'verify' ? 'active' : '',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this2.setActionMode('verify');
	                  }
	                },
	                'Verify'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'button',
	                type: 'button',
	                disabled: loading,
	                onClick: actionMode === 'generate' ? this.generate : this.verify
	              },
	              actionMode === 'generate' ? 'Generate bookmarklet' : 'Verify source'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panelHeader' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Bookmarklet'
	            )
	          ),
	          generatedBookmarklet ? _react2.default.createElement(
	            'div',
	            { className: 'bookmarkletRow' },
	            editingBookmarkletName ? _react2.default.createElement('input', {
	              className: 'bookmarkletNameInput',
	              'aria-label': 'Bookmarklet name',
	              autoFocus: true,
	              value: bookmarkletName,
	              onChange: function onChange(event) {
	                return _this2.setState({
	                  bookmarkletName: event.target.value,
	                  bookmarkletNameEdited: true
	                });
	              },
	              onBlur: this.finishBookmarkletNameEdit,
	              onKeyDown: this.handleBookmarkletNameKeyDown
	            }) : _react2.default.createElement(
	              'a',
	              {
	                className: 'bookmarkletLink',
	                href: generatedBookmarklet,
	                title: bookmarkletName,
	                draggable: 'true'
	              },
	              bookmarkletName
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'editNameButton',
	                type: 'button',
	                'aria-label': 'Edit bookmarklet name',
	                title: 'Edit bookmarklet name',
	                onClick: function onClick() {
	                  return _this2.setState({ editingBookmarkletName: true, bookmarkletNameEdited: true });
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                { 'aria-hidden': 'true' },
	                '\u270E'
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'dropZone',
	              onDrop: this.handleDrop,
	              onDragOver: function onDragOver(event) {
	                return event.preventDefault();
	              }
	            },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'bookmarklet' },
	              'Paste or drop a bookmarklet'
	            ),
	            _react2.default.createElement('textarea', {
	              id: 'bookmarklet',
	              value: bookmarklet,
	              spellCheck: 'false',
	              placeholder: 'javascript:(()=>{/*bm:v1;sha=...*/alert(\'hi\')})()',
	              onChange: function onChange(event) {
	                return _this2.setState({ bookmarklet: event.target.value });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'actions bookmarkletActions' },
	            _react2.default.createElement(
	              'button',
	              { className: 'button', type: 'button', disabled: loading, onClick: this.inspect },
	              'Inspect'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'button',
	                type: 'button',
	                disabled: loading || !bookmarklet && !generatedBookmarklet && !sharedSource,
	                onClick: this.clearBookmarklet
	              },
	              'Clear'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'button',
	                type: 'button',
	                disabled: loading || !generatedBookmarklet || !sourceUrl,
	                onClick: this.copyShareUrl
	              },
	              'Copy share URL'
	            )
	          ),
	          status ? _react2.default.createElement(
	            'p',
	            { className: 'status ' + statusType },
	            status
	          ) : null,
	          this.renderMetadata(),
	          inspection.metadataError ? _react2.default.createElement(
	            'p',
	            { className: 'status error' },
	            inspection.metadataError
	          ) : null,
	          inspection.decodeError ? _react2.default.createElement(
	            'p',
	            { className: 'status error' },
	            'Decode warning: ',
	            inspection.decodeError
	          ) : null,
	          _react2.default.createElement(
	            'details',
	            null,
	            _react2.default.createElement(
	              'summary',
	              null,
	              'Decoded JavaScript'
	            ),
	            _react2.default.createElement('textarea', { readOnly: true, value: inspection.decoded || '', spellCheck: 'false' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'docs' },
	        _react2.default.createElement(
	          'div',
	          { className: 'docBlock' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Why verifiable bookmarklets'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Bookmarklets are powerful: you can run JavaScript on almost any page by dragging a link to your bookmarks and clicking it. A verifiable bookmarklet keeps that workflow, while adding only a version, SHA-256 hash and optional source URL, so people can share one and prove that it came from the published source. Verification confirms the match, not the safety of the code.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'docBlock' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Metadata'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A verifiable bookmarklet is still a normal bookmarklet. It carries a small JavaScript comment immediately inside its wrapper, before the source runs:'
	          ),
	          _react2.default.createElement(
	            'code',
	            null,
	            '/*bm:v1;sha=<sha256>;src=<url>*/'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'code',
	                null,
	                'bm:v1'
	              ),
	              ' identifies the format.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'code',
	                null,
	                'sha'
	              ),
	              ' identifies the exact generated payload.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'code',
	                null,
	                'src'
	              ),
	              ' optionally points to the published source.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'docBlock' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'How verification works'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The generator normalizes the source, creates the bookmarklet payload and calculates its SHA-256 before inserting the metadata comment. The validator decodes the bookmarklet, rebuilds the payload and compares the hashes. It never executes the code.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A match proves the source corresponds to the bookmarklet. It does not prove that the code is safe or trustworthy.'
	          )
	        )
	      )
	    );
	  };
	
	  return VerifiableBookmarkletsPage;
	}(_react2.default.Component);
	
	exports.default = VerifiableBookmarkletsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-verifiable-bookmarklets-js-36c61b6ece89b446a910.js